<template>
  <div>
    <template v-if="informText != ''">
      <v-alert type="error">
        {{ informText }}
      </v-alert>
    </template>

    <v-data-table
      :headers="headers"
      :items="productProfitData"
      class="elevation-1"
      :loading="loading"
      :search="search"
      :footer-props="{ 'items-per-page-options': [10, 50, 100, -1] }"
      ref="dataTable"
      @pagination="sumDataFilter"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search Product"
            single-line
            hide-details
            class="shrink mx-4"
          ></v-text-field>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-btn @click="convertDataJSON">Export To Excel</v-btn>
          <v-divider class="mx-4" inset vertical></v-divider>
          <template>
            <b
              >Sum Orders:
              <span style="color: green">{{ sum_total_orders }}</span> 
              - Sum Sales:
              <span style="color: green">{{ sum_total_sales }}</span>
              - Sum Ad Spent:
              <span style="color: green"
                >${{ parseFloat(sum_total_ad_spent).toFixed(2) }}</span
              >
              - Sum Gross Profit:
              <span style="color: green"
                >${{ parseFloat(sum_gross_profit).toFixed(2) }}</span
              >
              - Sum Estimated Profit:
              <span style="color: green"
                >${{ parseFloat(sum_estimated_profit).toFixed(2) }}</span
              >
            </b>
          </template>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:item.product_code="{ item }">
        <img v-bind:src="item.product_thumbnail" style="width: 100px" />
        <div style="display: none">{{ item.product_code }}</div>
      </template>
      <template v-slot:item.product_tags="{ item }">
        <div v-for="(i, index) in item.product_tags" :key="index">
          {{ i }}
        </div>
      </template>
      <template v-slot:item.product_title="{ item }">
        <div>{{ item.product_code }}</div>
        <a
          @click="showNameItem(item)"
          v-if="item.showName == false"
          style="text-align: justify"
          >{{ item.short_title }}</a
        >
        <a @click="showNameItem(item)" v-else style="text-align: justify">{{
          item.product_title
        }}</a>
      </template>
      <template v-slot:item.revenue="{ item }">
        {{ parseFloat(item.revenue).toFixed(2) }}
      </template>
      <template v-slot:item.temp_profit="{ item }">
        {{ parseFloat(item.temp_profit).toFixed(2) }}
      </template>
      <template v-slot:item.gross_profit="{ item }">
        {{ parseFloat(item.gross_profit).toFixed(2) }}
      </template>
      <!-- <template v-slot:item.net_profit="{ item }">
        {{ parseFloat(item.net_profit).toFixed(2) }}
      </template> -->
      <template v-slot:item.estimated_profit="{ item }">
        {{ parseFloat(item.temp_profit - item.total_ad_spent).toFixed(2) }}
      </template>
      <template v-slot:item.facebook_ad_spent="{ item }">
        {{ parseFloat(item.facebook_ad_spent).toFixed(2) }}
      </template>
      <template v-slot:item.facebook_cost_per_purchase="{ item }">
        {{ parseFloat(item.facebook_cost_per_purchase).toFixed(2) }}
      </template>
      <template
        v-slot:item.facebook_website_purchases_conversion_value="{ item }"
      >
        {{ parseFloat(item.facebook_website_purchases_conversion_value).toFixed(2) }}
      </template>
      <template v-slot:item.google_ad_spent="{ item }">
        {{ parseFloat(item.google_ad_spent).toFixed(2) }}
      </template>
      <template v-slot:item.tiktok_ad_spent="{ item }">
        {{ parseFloat(item.tiktok_ad_spent).toFixed(2) }}
      </template>
      <template v-slot:item.total_ad_spent="{ item }">
        {{ parseFloat(item.total_ad_spent).toFixed(2) }}
      </template>
    </v-data-table>
  </div>
</template>


<script>
import axios from "axios";
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";
import XLSX from "xlsx";
import moment from "moment";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "ProfitProduct",
  props: {
    report_type: String,
    report_month: Array,
    store_codes: Array,
    productTypeSelected: String,
    tagsSelected: Array,
  },
  data: () => ({
    search: "",
    loading: false,
    headers: [
      {
        text: "Image",
        value: "product_code",
        align: "start",
        class: "sticky-header white",
      },
      { text: "Title", value: "product_title", class: "sticky-header white" },
      {
        text: "Idea",
        value: "idea",
        class: "sticky-header white",
      },
      { text: "Tag", value: "product_tags", class: "sticky-header white" },
      {
        text: "Total Order",
        value: "total_orders",
        class: "sticky-header white",
      },
      {
        text: "Total Sales",
        value: "total_sales",
        class: "sticky-header white",
      },
      { text: "Revenue", value: "revenue", class: "sticky-header white" },
      {
        text: "Temp Profit",
        value: "temp_profit",
        class: "sticky-header white",
      },
      {
        text: "Gross Profit",
        value: "gross_profit",
        class: "sticky-header white",
      },
      {
        text: "FB Ad Spent",
        value: "facebook_ad_spent",
        class: "sticky-header white",
      },
      // {
      //   text: "FB Web Purchases",
      //   value: "facebook_website_purchases",
      //   class: "sticky-header white",
      // },
      // {
      //   text: "FB Cost Per Purchase",
      //   value: "facebook_cost_per_purchase",
      //   class: "sticky-header white",
      // },
      // {
      //   text: "FB Web Purchases Conversion Value",
      //   value: "facebook_website_purchases_conversion_value",
      //   class: "sticky-header white",
      // },
      {
        text: "GG Ad Spent",
        value: "google_ad_spent",
        class: "sticky-header white",
      },
      {
        text: "Tiktok Ad Spent",
        value: "tiktok_ad_spent",
        class: "sticky-header white",
      },
      {
        text: "Total Ad Spent",
        value: "total_ad_spent",
        class: "sticky-header white",
      },
      //{ text: "Net Profit", value: "net_profit", class: "sticky-header white" },
      { text: "Estimated Profit", value: "estimated_profit", class: "sticky-header white" },
    ],
    productProfitData: [],
    showBtn: null,
    informText: "",
    convertData: {
      ProductProfit: [],
    },
    sum_total_orders: 0,
    sum_total_sales: 0,
    sum_gross_profit: 0,
    sum_total_ad_spent: 0,
    sum_estimated_profit: 0,
  }),

  methods: {
    sumDataFilter() {
      //console.log(pagination.itemsLength) // length of filtered/searched items in Vuetify data-table
      this.sum_total_orders = 0
      this.sum_total_sales = 0
      this.sum_gross_profit = 0
      this.sum_total_ad_spent = 0
      this.sum_estimated_profit = 0

      let itemsFiltered = this.$refs.dataTable.$children[0].filteredItems;
      //let lengthFiltered =  itemsFiltered.length
      console.log('itemsFiltered: ',itemsFiltered)
      for(let t of itemsFiltered)
      {
        this.sum_total_orders += t.total_orders
        this.sum_total_sales += t.total_sales
        this.sum_gross_profit += t.gross_profit
        this.sum_total_ad_spent += t.total_ad_spent
        this.sum_estimated_profit += (t.temp_profit - t.total_ad_spent)
      }
    },

    async loadData() {
      this.loading = true;
      this.sum_total_orders = 0;
      this.sum_total_sales = 0;
      this.sum_total_ad_spent = 0;
      this.sum_gross_profit = 0;
      this.sum_estimated_profit = 0;
      var queryParams = {
        report_type: this.report_type,
        store_codes: this.store_codes.join(","),
      };

      if (this.productTypeSelected != "") {
        queryParams["product_type_id"] = this.productTypeSelected;
      }

      // if (this.report_month != "") {
      //   queryParams["report_month"] = this.report_month;
      // }

      if(this.tagsSelected.length > 0){
        queryParams['tags'] = this.tagsSelected.join(",")
      }

      if (this.report_month.length > 0) {
        if (this.report_month[0] > this.report_month[1]) {
          queryParams["report_from"] = this.report_month[1];
          queryParams["report_to"] = this.report_month[0];
        } else {
          queryParams["report_from"] = this.report_month[0];
          queryParams["report_to"] = this.report_month[1];
        }
      }

      console.log(queryParams);

      var currentSession = await this.$root.$refs.App.currentSession(
        "product-profit-loadData"
      );
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "reports/profit", {
            headers: { Authorization: currentSession.accessToken },
            params: queryParams,
          })
          .then((response) => {
            console.log("response: ", response);
            if(response.data.error_message == ''){
              this.productProfitData = response.data.data;
              for (const y of this.productProfitData) {
                y.facebook_ad_spent = parseFloat(y.facebook_ad_spent.toFixed(2))
                y.google_ad_spent = parseFloat(y.google_ad_spent.toFixed(2))
                y.total_ad_spent = parseFloat(y.total_ad_spent.toFixed(2))

                this.sum_total_orders += y.total_orders;
                this.sum_total_sales += y.total_sales;
                this.sum_total_ad_spent += y.total_ad_spent;
                this.sum_gross_profit += y.gross_profit;
                this.sum_estimated_profit += (y.temp_profit - y.total_ad_spent);
                if (y.product_title) {
                  y["short_title"] = y.product_title
                    .substring(0, 35)
                    .concat("...");
                  y["showName"] = false;
                }
              }
              console.log("this.productProfitData: ", this.productProfitData);
              this.loading = false;
            }else{
              this.informText = response.data.error_message
            }
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log(
          "currentSession product-profit-loadData-undefined: ",
          currentSession
        );
      }
    },

    showNameItem(item) {
      var temp = [];
      var index = this.productProfitData.indexOf(item);
      if (this.productProfitData[index].showName == false) {
        this.productProfitData[index].showName = true;

        this.productProfitData.push(temp);
        this.productProfitData.splice(this.productProfitData.length - 1, 1);
      } else {
        this.productProfitData[index].showName = false;

        this.productProfitData.push(temp);
        this.productProfitData.splice(this.productProfitData.length - 1, 1);
      }
    },

    convertDataJSON() {
      //console.log(this.productProfitData)
      for (const i of this.productProfitData) {
        var temp = {
          Image: i.product_thumbnail,
          "Product Code": i.product_code,
          Title: i.product_title,
          Idea: i.idea,
          Tag: i.product_tags.join(", "),
          "Total Order": i.total_orders,
          "Total Sales": i.total_sales,
          Revenue: parseFloat(i.revenue).toFixed(2),
          "Temp Profit": parseFloat(i.temp_profit).toFixed(2),
          "Gross Profit": parseFloat(i.gross_profit).toFixed(2),
          "FB Ad Spent": parseFloat(i.facebook_ad_spent).toFixed(2),
          // "FB Web Purchases": i.facebook_website_purchases,
          // "FB Cost Per Purchase": parseFloat(
          //   i.facebook_cost_per_purchase
          // ).toFixed(2),
          // "FB Web Purchases Conversion Value": parseFloat(
          //   i.facebook_website_purchases_conversion_value
          // ).toFixed(2),
          "GG Ad Spent": parseFloat(i.google_ad_spent).toFixed(2),
          "Tiktok Ad Spent": parseFloat(i.tiktok_ad_spent).toFixed(2),
          "Total Ad Spent": parseFloat(i.total_ad_spent).toFixed(2),
          "Estimated Profit": parseFloat(i.temp_profit - i.total_ad_spent).toFixed(2),
          //"Net Profit": parseFloat(i.net_profit).toFixed(2),
          //ROI: parseFloat(i.roi).toFixed(2) || "NaN",
          //"Total Real ROAS": parseFloat(i.total_real_roas).toFixed(2) || "NaN",
        };
        this.convertData.ProductProfit.push(temp);
      }

      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      for (const a in this.convertData) {
        var b = XLSX.utils.json_to_sheet(this.convertData[a]);
        XLSX.utils.book_append_sheet(wb, b, a);
      }

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      var current = moment().format("YYYY-MM-DD-h-mm-ss");
      // export Excel file
      XLSX.writeFile(wb, "product_profit_" + current + ".xlsx"); // name of the file is 'book.xlsx'
    },

    check() {
      console.log(this.editedItem);
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },

  async mounted() {
    console.log("report_type: ", this.report_type);
    console.log("report_month: ", this.report_month);
    console.log("store_codes: ", this.store_codes);
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
.v-data-table /deep/ .sticky-header {
  position: sticky;
  top: 0;
}

.v-data-table /deep/ .v-data-table__wrapper {
  overflow: unset;
}
</style>